import { ActivityFeedItemType } from 'components/activity-feed/activity-feed-header/activity-feed-item-type'
import { forRails } from 'components/for-rails'
import { RailsReactionBar } from 'components/reaction-bar'
import { RailsWinsSecondaryNav } from '../src/components/wins-secondary-nav'
import { registerComponents } from '../src/utils/react/registry'
import { SkillActivityFeed } from 'components/skill-activity-feed'
import { VisibilityIcon } from 'components/visibility-icon'
import { CreateFormModalButton } from 'components/create-form-modal'
import { WinOverflowMenu } from 'components/win-overflow-menu/win-overflow-menu'
import { WinsPage } from 'pages/wins-page'

registerComponents({
  RailsReactionBar: forRails(RailsReactionBar),
  VisibilityIcon: forRails(VisibilityIcon),
  WinsSecondaryNav: forRails(RailsWinsSecondaryNav),
  WinsPage: forRails(WinsPage),
  SkillActivityFeed: forRails(SkillActivityFeed),
  ActivityFeedItemType: forRails(ActivityFeedItemType),
  CreateFormModalButton: forRails(CreateFormModalButton),
  WinOverflowMenu: forRails(WinOverflowMenu),
})
